<template>
  <main>
    <div class="courses-all">
      <div class="section-frame">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/news">
              <div>{{ $t("all_news") }}</div></router-link
            >
          </li>
        </ul>
        <div class="page-sub-title">
          <h1>
            <i class="fa-title"></i>
            <div>{{ $t("all_news") }}</div>
          </h1>
        </div>
        <div class="courses-all-frame">
          <div class="courses-all-box">
            <div class="courses-all-list" v-if="news">
              <div
                class="news-slide news-item"
                v-for="(item, index) in news.result"
                :key="index"
              >
                <div class="news-photo">
                  <img
                    :src="
                      item.image_url
                        ? $mediaUrl(item.image_url)
                        : require('../assets/images/news/news.jpg')
                    "
                    alt=""
                  />
                </div>
                <div class="news-info">
                  <div class="news-item-title">
                    <h3>{{ item.title }}</h3>
                    <p v-extract v-html="$processHtml(item.content)"></p>
                  </div>
                  <div class="news-date">
                    <span>{{ item.date_created }}</span>
                    <router-link :to="`/news/${item.slug}`"
                      ><div>{{ $t("read") }}</div></router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="courses-all-list">
              <v-loader />
            </div>
          </div>
        </div>

        <template v-if="loading">
          <a
            href="#"
            v-if="news && !(news.last_page === news.page)"
            class="courses-all-hide"
          >
            <img src="../assets/images/status/load.svg" alt="" />
          </a>
        </template>
        <template v-else>
          <a
            href="#"
            v-if="news && !(news.last_page === news.page)"
            @click.prevent.stop="paginationCourse"
            class="courses-all-hide"
          >
            {{ $t("more_courses") }}
            <i class="fa-arrow-line"></i>
          </a>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  title: "Yangiliklar",
  data() {
    return {
      loading: false,
    };
  },
  async mounted() {
    await this.$store.dispatch("getNews");
  },
  methods: {
    async paginationCourse() {
      this.loading = true;
      await this.$store.dispatch("paginationNews", this.news.page + 1);
      this.loading = false;
    },
  },
  computed: {
    news() {
      return this.$store.getters.getNews;
    },
  },
  components: {},
};
</script>
